import {FIELD_ORDER_UI_SCHEMA_KEY, ShapeUISchemaNestedShapeValues} from '../../StepConfigEditorTypes';
import {
  createLegendStyleSection,
  GRADIENT_COLOR_PALETTE_DISPLAY_NAMES,
  GRADIENT_COLOR_PALETTE_SVG_PATHS,
} from './ChartSchemaHelpers';

/**
 * Heatmap configuration sections for the Configure tab
 */
export const HEATMAP_CONFIG_SECTIONS = {
  [FIELD_ORDER_UI_SCHEMA_KEY]: ['configSection', 'colorPaletteSection'],
  configSection: {
    [FIELD_ORDER_UI_SCHEMA_KEY]: ['rows', 'columns', 'metric', 'gradientDirection'],
    rows: {
      displayName: 'Rows',
      configShapePath: ['chartConfig', 'parameters', 'yAxisColumnName'],
    },
    columns: {
      displayName: 'Columns',
      configShapePath: ['chartConfig', 'parameters', 'xAxisColumnName'],
    },
    metric: {
      displayName: 'Metric',
      configShapePath: ['chartConfig', 'parameters', 'metricColumnName'],
    },
    gradientDirection: {
      displayName: 'Gradient direction',
      configShapePath: ['chartConfig', 'parameters', 'gradientDirection'],
      fieldSettings: {
        displayNames: {
          ASCENDING_METRIC_VALUES: 'Ascending',
          DESCENDING_METRIC_VALUES: 'Descending',
        },
      },
    },
  },
  colorPaletteSection: {
    [FIELD_ORDER_UI_SCHEMA_KEY]: ['gradientColorPalette'],
    gradientColorPalette: {
      displayName: 'Color palette',
      configShapePath: ['chartConfig', 'parameters', 'gradientColorPalette'],
      fieldSettings: {
        defaultValue: 'BLUES',
        displayNames: GRADIENT_COLOR_PALETTE_DISPLAY_NAMES,
        svgImagePaths: GRADIENT_COLOR_PALETTE_SVG_PATHS,
      },
    },
  },
} as const satisfies ShapeUISchemaNestedShapeValues;

export const HEATMAP_STYLE_SECTIONS = {
  [FIELD_ORDER_UI_SCHEMA_KEY]: ['legendSection'],
  legendSection: createLegendStyleSection({disableFn: false}),
} as const satisfies ShapeUISchemaNestedShapeValues;
